import errorHandling from './errorHandling';

export const errorHandlingEpic = errorHandling;
